import { recoverPassword, AuthError } from '@theme/customer-auth';

const form = document.querySelector('[data-forgot-password-form]');

if (form) {
  const card = form.closest('.customer-auth__card');
  const errorEl = card.querySelector('[data-auth-error]');
  const successEl = card.querySelector('[data-auth-success]');
  const submitButton = form.querySelector('[data-submit-button]');
  const submitLabel = submitButton.querySelector('[data-submit-label]');
  const submitLabelDefault = submitLabel.textContent;
  const submitLabelBusy = submitButton.dataset.busyLabel || submitLabelDefault;

  form.addEventListener('submit', async (event) => {
    event.preventDefault();
    errorEl.hidden = true;
    successEl.hidden = true;
    submitButton.disabled = true;
    submitButton.setAttribute('aria-busy', 'true');
    submitLabel.textContent = submitLabelBusy;

    const formData = new FormData(form);

    try {
      await recoverPassword(formData.get('email'));
      successEl.hidden = false;
      form.reset();
    } catch (error) {
      const message =
        error instanceof AuthError && error.customerUserErrors.length
          ? error.customerUserErrors.map((e) => e.message).join(' ')
          : null;

      errorEl.textContent = message || errorEl.dataset.genericError;
      errorEl.hidden = false;
    } finally {
      submitButton.disabled = false;
      submitButton.removeAttribute('aria-busy');
      submitLabel.textContent = submitLabelDefault;
    }
  });
}
